import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactEcharts from "echarts-for-react";
import ArrowUp from "../../assets/images/arrow-up.png"
import ArrowDown from "../../assets/images/arrow-down.png"
import EnrollmentImg from "../../assets/images/Enrollment_banner.jpg";
import 'primereact/resources/themes/lara-light-indigo/theme.css';   // theme
import 'primereact/resources/primereact.css';
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStudent_Enrollment_By_Year,
  fetchStudent_Enrollment_By_Grade, fetchStudent_Enrollment_Report
} from '../../redux/slices/counter';
import LoaderContainer from "../../components/LoaderContainer/LoaderContainer";
import { Tooltip } from "primereact/tooltip";

export default function Enrollment() {
  const dispatch = useDispatch();
  const Student_Enrollment_By_Yeardata = useSelector(state => state.netsales.Student_Enrollment_By_Year);
  const Student_Enrollment_By_Gradedata = useSelector(state => state.netsales.Student_Enrollment_By_Grade);
  const Student_Enrollment_Reportdata = useSelector(state => state.netsales.Student_Enrollment_Report);

  // page loaders state
  const Student_Enrollment_Reportloadingdata = useSelector(state => state.netsales.Student_Enrollment_Reportloading)
  const Student_Enrollment_By_Gradeloadingdata = useSelector(state => state.netsales.Student_Enrollment_By_Gradeloading)
  const Student_Enrollment_By_Yearloadingdata = useSelector(state => state.netsales.Student_Enrollment_By_Yearloading)

  const gradeOrder = ["Y5s", "KG", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
  let Student_Enrollment_By_Gradedatasort = [...Student_Enrollment_By_Gradedata]?.sort(
    (a, b) => (gradeOrder.indexOf(a.KEY) !== -1 ? gradeOrder.indexOf(a.KEY) : 99) -
      (gradeOrder.indexOf(b.KEY) !== -1 ? gradeOrder.indexOf(b.KEY) : 99)
  );

  const TooltipAttributes2 = ({ categoryLabel }) => {
    return {
      'data-pr-tooltip': `${categoryLabel}`,
      'data-pr-position': 'top-0',
      'data-pr-my': 'left-40 bottom-0',
      'data-pr-at': 'center top',
      'data-pr-className': 'custom-tooltip',
      style: { cursor: 'pointer' }
    }
  }

  const TooltipAttributes1 = ({ categoryLabel }) => {
    return {
      'data-pr-tooltip': `Variance from Last Year ${categoryLabel?.toLocaleString()}`,
      'data-pr-position': 'top',
      'data-pr-my': 'left-40 bottom',
      'data-pr-at': 'center top-5',
      'data-pr-className': 'custom-tooltip',
      style: { cursor: 'pointer' }
    }
  }

  const [screenWidth, setScreenWidth] = useState(0);
  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== 'undefined') {
        const screenWidth = window.innerWidth;
        setScreenWidth(screenWidth);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    dispatch(fetchStudent_Enrollment_By_Year({
      "elasticQueryName": "Student_Enrollment_By_Year",
      "filters": [],
      "dynamicColumns": [],
    }));
    dispatch(fetchStudent_Enrollment_By_Grade({
      "elasticQueryName": "Student_Enrollment_By_Grade",
      "filters": [{
      columnName: "SCHOOL_YEAR",
      columnValue: "2027",
      excludeKeyword: false,
    }],
      "dynamicColumns": [],
    }));
    dispatch(fetchStudent_Enrollment_Report({
      "elasticQueryName": "Student_Enrollment_Report",
      "filters": [{
      columnName: "SCHOOL_YEAR",
      columnValue: "2027",
      excludeKeyword: false,
    }],
      "dynamicColumns": [],
    }));
  }, [])


  const StudentEnrollmentbyGrade = {
    tooltip: {
      trigger: 'item',
      backgroundColor: 'rgba(50,50,50,0.7)',
      borderColor: "#333",
      textStyle: {
        fontSize: 12,
        fontWeight: "normal",
        color: '#fff',
      },
      axisPointer: {
        type: 'shadow'
      },
      formatter: function (params) {
        const dataPoint = Student_Enrollment_By_Gradedatasort?.find(d => d.KEY === params.name);

        if (dataPoint) {
          return `${params.marker} ${params.name}: <b>${dataPoint?.GROUPBY_METRIC_NUMERATOR?.toLocaleString()} (${dataPoint.PERCENTAGE}%)</b>`;
        }
        return `${params.marker} ${params.name}: ${params.value}`;
      },

    },

    title: {
      text: 'Student Enrollment by Grade',
      left: 10,
      textStyle: {
        fontSize: 14,
        fontWeight: "normal",
        color: '#fff',

      },
    },

    grid: {
      left: '5%',
      right: '5%',
      bottom: '0%',
      top: "20%",
      containLabel: true
    },
    yAxis: [
      {
        type: 'value',
        axisLine: {
          show: false,
          lineStyle: {
            color: '#fff'
          }
        },
        // min: 0,
        // max: 10000,
        // interval: 1000,
        axisLabel: {
          show: false,
          color: '#fff'
        },
        splitLine: {
          show: false,
          lineStyle: {
            show: false,
            type: "dashed"
          },
        },
      },
    ],
    xAxis: {
      type: 'category',
      data: Student_Enrollment_By_Gradedatasort?.filter(ele => ele?.KEY != null).map(itr => itr.KEY),

      axisTick: {
        show: false
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: '#E0E0E0'
        }
      },
      axisLabel: {
        color: '#fff',
        interval: 0,
        rotate: 50,
        fontSize: 11,
      },
    },
    series: [
      {
        // name: 'Revenue 2021',
        type: 'bar',
        stack: 'Profit',
        barWidth: "10px",
        color: '#B55D5D',

        data: Student_Enrollment_By_Gradedatasort.map(itr => itr.GROUPBY_METRIC_NUMERATOR),
        emphasis: {
          focus: 'series'
        },
        itemStyle: {
          normal: {
            barBorderRadius: [2, 2, 2, 2],
          }
        }
      },

      // {
      //   name: 'Revenue 2022',
      //   type: 'line',
      //   stack: 'Expenses 2022',
      //   color: '#FFA600',
      //   symbolSize: 0,
      //   // data: [21000, 20000, 21000, 23000, 20000, 23000, 26000,24000,25000],
      //   // lineStyle: {
      //   //   width: 3,
      //   // },
      // },

    ]
  };
  const memoizedChartOption = useMemo(() => StudentEnrollmentbyGrade, [Student_Enrollment_By_Gradedatasort]);

  const Intervals = 1;
  const maxValue = Math.max(...Student_Enrollment_By_Yeardata.map(itr => itr.VALUE))
  const minValue = Math.min(...Student_Enrollment_By_Yeardata.map(itr => itr.VALUE))
  const IntervalsStep = Math.ceil((maxValue - minValue) / Intervals);

  const StudentEnrollmentbyYear = {
    title: {
      text: 'Student Enrollment by Year',
      left: 10,
      textStyle: {
        fontSize: 12,
        fontWeight: "normal",
        color: '#fff',
      },
    },
    color: ['#62534A'],
    tooltip: {
      backgroundColor: 'rgba(50,50,50,0.7)',
      borderColor: "#333",
      textStyle: {
        fontSize: 12,
        fontWeight: "normal",
        color: '#fff',
      },
      trigger: 'axis',
      axisPointer: {
        type: 'line',
        lineStyle: {
          type: "line"
        }
      },
      formatter: function (params) {

        if (Array?.isArray(params)) {
          return params.map(param => {
            return `${`Year ` + param.axisValueLabel}: ${param.value?.toLocaleString()}`;
          }).join('<br/>');
        } else {
          return `${params.axisValueLabel}: ${params.value?.toLocaleString()}`;
        }
      }
    },
    grid: {
      tooltip: {
        padding: [100, 100, 100, 100],
        backgroundColor: 'rgba(50,50,50,0.7)',
        borderColor: "#333",
        color: '#fff'
      }
    },

    grid: {
      right: '0%',
      bottom: '10%',
      top: '40%',
      left: '0%'
    },

    yAxis: [
      {
        type: 'value',
        show: false,
        axisLine: {
          show: false,
          lineStyle: {
            color: '#E0E0E0'
          }
        },
        axisLabel: {
          show: false,
          color: '#4F4F4F'
        },
        splitLine: {
          lineStyle: {
            show: false,
            type: "dashed"
          },
        },
        min: minValue - 1000,  // Adjust based on data range
        max: maxValue,
        interval: IntervalsStep,
      },
    ],
    xAxis: {
      type: 'category',
      data: Student_Enrollment_By_Yeardata.map(itr => itr.LABEL),
      position: "bottom",
      offset: 25,
      axisTick: {
        show: false
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: '#E0E0E0'
        }
      },
      axisLabel: {
        inside: true,
        color: '#fff'
      },
      z: 10
    },
    series: [
      {
        data: Student_Enrollment_By_Yeardata.map(itr => itr.VALUE),
        type: 'line',
        areaStyle: {},
        label: {
          show: true,
          position: 'top',
          textShadowBlur: false,
          color: '#fff',
          formatter: (params) => {
            return params.value.toLocaleString();
          }
        },
      },
    ]

  };

  const memoizedChartOption1 = useMemo(() => StudentEnrollmentbyYear, [Student_Enrollment_By_Yeardata]);

  const MyChart = React.memo(({ options }) => {
    return <ReactEcharts option={options} notMerge={true} lazyUpdate={true} style={{ width: '100%', height: screenWidth <= 1450 && screenWidth >= 1100 ? 110 : 120 }} />;
  });


  const Student_Enrollment_ReportdataTotal = Student_Enrollment_Reportdata.filter(item => item.METRIC_NAME === "Total enrollment")
  const Student_Enrollment_ReportdataNew = Student_Enrollment_Reportdata.filter(item => item.METRIC_NAME === "Newly Enrolled Students")
  const Student_Enrollment_ReportdataLoss = Student_Enrollment_Reportdata.filter(item => item.METRIC_NAME === "Loss Count")

  return (
    <div className="bg-[#0F0D0B] text-[#fff] h-[100%] rounded-[7px]">
      <div className="relative h-[190px]">
        <div className=" h-[180px] ">
          <img src={EnrollmentImg} className="h-[190px] w-full " />
        </div>
        <div className="w-full absolute bottom-0 h-[40px] bg-[#0f0d0bb3] py-2 px-3">
          <h3 className="text-[16.2px] text-[#fff]">Enrollment</h3>
        </div>
      </div>
      <LoaderContainer height={"100px"} width={"100%"} loading={Student_Enrollment_Reportloadingdata} className="mt-5">
        <div className="mt-5 flex gap-6 items-center px-4">
          <Tooltip target=".custom-target-icon" />
          <div className="custom-target-icon" {...TooltipAttributes2({ categoryLabel: Student_Enrollment_ReportdataTotal[0]?.METRIC_DESCRIPTION })}>
            <p className="text-[14.2px] font-normal leading-3" >Total</p>
            <h4 className="text-[16px] font-semibold custom-target-icon" >{Student_Enrollment_ReportdataTotal[0]?.METRIC_NUMERATOR != null && Student_Enrollment_ReportdataTotal[0]?.METRIC_NUMERATOR !== undefined
              ? formatNumber(Student_Enrollment_ReportdataTotal[0]?.METRIC_NUMERATOR)
              : '-'}</h4>
          </div>
          <Tooltip target=".custom-target-icon" />
          <div style={{ position: "relative", top: "6px" }}
            className="relative group cursor-pointer custom-target-icon" {...TooltipAttributes1({ categoryLabel: Student_Enrollment_ReportdataTotal[0]?.METRIC_NUMERATOR_PY1 })} >
            {
              Student_Enrollment_ReportdataTotal[0]?.GROUPBY_VARIANCE <= 0 ? <div className="smallarrowbtndown" style={{ fontSize: "12px", fontWeight: 550 }}>
                <img src={ArrowDown} className="h-2.5 w-2.5" /> {Student_Enrollment_ReportdataTotal[0]?.GROUPBY_VARIANCE?.toFixed(1)}%

              </div> :
                <div className="smallarrowbtn" style={{ fontSize: "12px", fontWeight: 550 }}>
                  <img src={ArrowUp} className="h-2.5 w-2.5" /> {Student_Enrollment_ReportdataTotal[0]?.GROUPBY_VARIANCE?.toFixed(1)}%


                </div>

            }

          </div>
          {/* <div style={{ fontSize: "12px", position: "relative", right: "15px", top: "7px" }}>Last Year Variance Comparison</div> */}
        </div>
        <div className="grid grid-cols-2 gap-4 px-4 my-2">

          {/* New */}
          <div className="flex-col relative group">
            <p className="text-[12.2px] font-normal leading-5 mb-1 custom-target-icon" {...TooltipAttributes2({ categoryLabel: Student_Enrollment_ReportdataNew[0]?.METRIC_DESCRIPTION })}>New</p>

            <Tooltip style={{ cursor: 'pointer'}} className="custom-tooltip" position="top-0" my="left-40 bottom-0" at="center top" target=".custom-target-icon-Newtext">
              <h4>Variance from Last Year {Student_Enrollment_ReportdataNew[0]?.METRIC_NUMERATOR_PY1} <br/> New: {formatNumber(Student_Enrollment_ReportdataNew[0]?.METRIC_NUMERATOR)} ({Student_Enrollment_ReportdataNew[0]?.PERCENTAGE?.toFixed(1)}%)</h4>
            </Tooltip>

            <div className="flex justify-items-center custom-target-icon-Newtext">
              <p className="text-[16px] font-semibold leading-6 mr-2" >
                {formatNumber(Student_Enrollment_ReportdataNew[0]?.METRIC_NUMERATOR)}
              </p>

              {
                Student_Enrollment_ReportdataNew[0]?.GROUPBY_VARIANCE <= 0 ?
                  <div className="smallarrowbtndown whitespace-nowrap" style={{ fontSize: "12px" }}>
                    <img src={ArrowDown} className="h-2.5 w-2.5" />
                    {Student_Enrollment_ReportdataNew[0]?.GROUPBY_VARIANCE?.toFixed(1)}%
                  </div> :
                  <div className="smallarrowbtn whitespace-nowrap" style={{ fontSize: "12px" }}>
                    <img src={ArrowUp} className="h-2.5 w-2.5" />
                    {Student_Enrollment_ReportdataNew[0]?.GROUPBY_VARIANCE?.toFixed(1)}%
                  </div>

              }
            </div>

            {/* Tooltip */}
            {/* <div
              className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-0.5 w-max  bg-gray-700 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity"
              style={{

                backgroundColor: "black",
                color: "white",
                borderRadius: "6px",
                fontSize: "12px",
                whiteSpace: "normal",
                maxWidth: "150px",
                wordWrap: "break-word",
                textAlign: "center",
                boxShadow: "0px 2px 5px rgba(1,1,100,1.3)",
              }}
            >
              {`There is a ${Student_Enrollment_ReportdataNew[0]?.GROUPBY_VARIANCE > 0 ? "Increase" : "decrease"} by ${Math.abs((Student_Enrollment_ReportdataNew[0]?.GROUPBY_VARIANCE))?.toFixed(1) + "%"} compared to Last Year`}
            </div> */}
          </div>

          {/* Loss */}
          <div className="flex-col relative group  ">
            <p className="text-[12.2px] font-normal leading-5 mb-1 cursor-pointer custom-target-icon" {...TooltipAttributes2({ categoryLabel: Student_Enrollment_ReportdataLoss[0]?.METRIC_DESCRIPTION })}>Loss</p>

            <Tooltip style={{ cursor: 'pointer'}} className="custom-tooltip" position="top-0" my="left-40 bottom-0" at="center top" target=".custom-target-icon-Losstext">
              <h4>Variance from Last Year {Student_Enrollment_ReportdataLoss[0]?.METRIC_NUMERATOR_PY1} <br/> Loss: {formatNumber(Student_Enrollment_ReportdataLoss[0]?.METRIC_NUMERATOR)} ({Student_Enrollment_ReportdataLoss[0]?.PERCENTAGE?.toFixed(1)}%)</h4>
            </Tooltip>
            
            <div className="flex justify-items-center custom-target-icon-Losstext">
              <p className="text-[16px] font-semibold leading-6 mr-2 " >
                {Student_Enrollment_ReportdataLoss[0]?.METRIC_NUMERATOR != null && Student_Enrollment_ReportdataLoss[0]?.METRIC_NUMERATOR !== undefined
                  ? formatNumber(Student_Enrollment_ReportdataLoss[0]?.METRIC_NUMERATOR)
                  : '-'}
              </p>

              {
                Student_Enrollment_ReportdataLoss[0]?.GROUPBY_VARIANCE <= 0 ?
                  <div className="smallarrowbtn whitespace-nowrap" style={{ fontSize: "12px" }}>
                    <img src={ArrowDown} className="h-2.5 w-2.5" />
                    {Student_Enrollment_ReportdataLoss[0]?.GROUPBY_VARIANCE?.toFixed(1)}%
                  </div> :
                  <div className="smallarrowbtndown whitespace-nowrap" style={{ fontSize: "12px" }}>
                    <img src={ArrowUp} className="h-2.5 w-2.5" />
                    {Student_Enrollment_ReportdataLoss[0]?.GROUPBY_VARIANCE?.toFixed(1)}%
                  </div>

              }
            </div>
            {/* Tooltip */}
            {/* <div
              className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-0.5 w-max  bg-gray-700 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity"
              style={{

                backgroundColor: "black",
                color: "white",
                borderRadius: "6px",
                fontSize: "12px",
                whiteSpace: "normal",
                maxWidth: "150px",
                wordWrap: "break-word",
                textAlign: "center",
                boxShadow: "0px 2px 5px rgba(1,1,100,1.3)",
              }}
            >
              {`There is a ${Student_Enrollment_ReportdataLoss[0]?.GROUPBY_VARIANCE > 0 ? "Increase" : "decrease"} by ${Math.abs((Student_Enrollment_ReportdataLoss[0]?.GROUPBY_VARIANCE))?.toFixed(1) + "%"} compared to Last Year`}
            </div> */}
          </div>
        </div>

      </LoaderContainer>
      <div className="border-t border-[#ffffff26]">
        <LoaderContainer height={"140px"} width={"100%"} loading={Student_Enrollment_By_Gradeloadingdata} className="mt-5">
          <div className="h-[180px] mt-5 mb-1 center-align-echarts StudentEnrollmentbyGrade">
            <MyChart options={memoizedChartOption} />

            {/* <ReactEcharts notMerge={true} lazyUpdate={true} style={{ width: screenWidth <= 1450 && screenWidth >= 1100 ? 240 : 300, height: screenWidth <= 1450 && screenWidth >= 1100 ? 110 : 120 }} option={memoizedChartOption} /> */}
          </div>
        </LoaderContainer>
      </div>
      <div className="border-t border-[#ffffff26] mb-6">
        <LoaderContainer height={"180px"} width={"100%"} loading={Student_Enrollment_By_Yearloadingdata} className=" mt-0.5 StudentEnrollmentbyYear">
          <div className="StudentEnrollmentbyYear mb-0">
            <MyChart options={memoizedChartOption1} />

            {/* <ReactEcharts notMerge={true} lazyUpdate={true} style={{ width: screenWidth <= 1450 && screenWidth >= 1100 ? 240 : 280, height: screenWidth <= 1450 && screenWidth >= 1100 ? 110 : 120 }} option={memoizedChartOption1} /> */}
            {/* <ReactEcharts style={{ width: screenWidth <= 1450 && screenWidth >= 1100 ? 240 : 280, height: screenWidth <= 1450 && screenWidth >= 1100 ? 110 : 120 }} option={StudentEnrollmentbyYear} /> */}
          </div>
        </LoaderContainer>
      </div>
    </div>
  )
}


export const formatNumber = (num) => {
  const formatter = new Intl.NumberFormat('en-US');
  return formatter.format(num);
}
